import MongoModel from './MongoModel'
import { required, string } from 'vue-mc/validation'

export default class Analysis extends MongoModel {
  modelName = 'Analysis'
  collection = 'analysis'
  autoFields = true

  defaults () {
    return {
      id: null,
      name: null,
      organization: null,
      model: null,
      report: null,
      chartType: null,
      pivotData: null
    }
  }

  mutations () {
    return {
    }
  }

  validation () {
    return {
      name: string.and(required)
    }
  }

  options () {
    return {
      validateOnChange: false
    }
  }
}
